import { Button } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppActions } from '../../app/slice';
import { getUserPrivacySubpageUrl } from '../../base/historyService';
import { ChallengeSelectors } from '../../challenge';
import { IState } from '../../store/state';
import { CHALLENGE_LIST_SIZE } from '../constants';
import * as Selectors from '../selectors';
import { HighscoresActions } from '../slice';
import { getChallengeButtonLabelPostfix } from '../utils';
import './ChallengeFooter.scss';
import Pagination from './Pagination';

const ChallengeHighscoresFooter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const challengeWorkoutIds = ChallengeSelectors.getChallengeWorkoutIds();
  const todaysChallengeWorkoutId = ChallengeSelectors.getTodaysChallengeWorkoutId();
  const isFirstDayOfChallenge = ChallengeSelectors.isFirstDayOfChallenge();
  const isLastDayOfChallenge = ChallengeSelectors.isLastDayOfChallenge();
  const total = useSelector(Selectors.getTotalUsers);
  const page = useSelector(Selectors.getHighscoresPage);

  const hasPartaken = useSelector((state: IState) =>
    ChallengeSelectors.hasCompletedAChallengeWorkout(state, challengeWorkoutIds)
  );
  const hasCompletedToday = useSelector((state: IState) =>
    ChallengeSelectors.hasCompletedTodaysChallenge(state, todaysChallengeWorkoutId)
  );

  const buttonKey = useMemo(
    () => getChallengeButtonLabelPostfix(!!hasPartaken, hasCompletedToday, isFirstDayOfChallenge, isLastDayOfChallenge),
    [hasPartaken, hasCompletedToday, isFirstDayOfChallenge, isLastDayOfChallenge]
  );

  const privacyUrl = getUserPrivacySubpageUrl();

  const changePageCallback = (page: number) => dispatch(HighscoresActions.loadHighscoresPage(page));

  const handleClick = () => {
    if (!hasPartaken) {
      dispatch(AppActions.joinChallenge());
      return;
    }

    dispatch(AppActions.startChallenge());
  };

  return (
    <div className="leaderboard-footer">
      <Button onClick={handleClick} label={t(`ChallengeLeaderboard.CTA.${buttonKey}`)} disabled={hasCompletedToday} />
      <div className="leaderboard-pagination">
        {total > 0 && (
          <Pagination
            numberOfRecords={total}
            currentPage={page}
            itemsPerPage={CHALLENGE_LIST_SIZE}
            onChangePage={changePageCallback}
          />
        )}
        <a className="privacy-link" href={privacyUrl}>
          {t('Highscore.PrivacyLink')}
        </a>
      </div>
    </div>
  );
};

export default ChallengeHighscoresFooter;
